import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  ProjectFieldDefinition: {
    fields: {
      configuration: {
        merge: (existing, incoming) => ({ ...existing, ...incoming }),
      },
      isSystemField: {
        merge: (existing, incoming) => incoming ?? existing,
        read: (existing) => existing ?? false,
      },
    },
  },
};
